import { render, staticRenderFns } from "./CarModelSelection.vue?vue&type=template&id=2b1ff760&scoped=true"
import script from "./CarModelSelection.vue?vue&type=script&lang=js"
export * from "./CarModelSelection.vue?vue&type=script&lang=js"
import style0 from "./CarModelSelection.vue?vue&type=style&index=0&id=2b1ff760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ff760",
  null
  
)

export default component.exports